import React, { useEffect } from 'react';
import { IconButton, Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { SvgNavigationMenuRegular } from '@insights-ltd/design-library/components';
import HeaderLayout from './HeaderLayout';
import MobileNavBarDialog from './MobileNavBarDialog';
import { NavBar } from './NavBar';

const Header = () => {
  const aboveMobile = useMediaQuery(
    (theme: Theme) => theme.breakpoints.up('sm'),
    { noSsr: true },
  );
  const [dialogOpen, setDialogOpen] = React.useState(false);

  useEffect(() => {
    if (aboveMobile) setDialogOpen(false);
  }, [aboveMobile]);

  return (
    <>
      <HeaderLayout>
        {aboveMobile ? (
          <NavBar />
        ) : (
          <Grid
            container
            data-testid="mobile-header"
            sx={{
              justifyContent: 'flex-end',
            }}
          >
            <IconButton
              onClick={() => setDialogOpen(true)}
              aria-label="Open Menu Button"
              size="small"
              sx={{ textAlign: 'right' }}
            >
              <SvgNavigationMenuRegular />
            </IconButton>
          </Grid>
        )}
      </HeaderLayout>
      <MobileNavBarDialog
        open={dialogOpen}
        closeDialog={() => setDialogOpen(false)}
      />
    </>
  );
};

export default Header;
